import React from 'react';
import ResumeContainer from '../components/resume-components/ResumeContainer';

export default function Resume() {
    return (
        <div className="main-section">
            <ResumeContainer />
        </div>
    );
}